'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _fileuploader = require('../fileuploader');

var _fileuploader2 = _interopRequireDefault(_fileuploader);

var _chatmessage = require('./chatmessage');

var _chatmessage2 = _interopRequireDefault(_chatmessage);

var _chatevent = require('./chatevent');

var _chatevent2 = _interopRequireDefault(_chatevent);

var _constants = require('../../common/constants');

var Constants = _interopRequireWildcard(_constants);

var _chatTyping = require('./chatTyping');

var _chatTyping2 = _interopRequireDefault(_chatTyping);

var _chatservice = require('../../services/chatservice');

var _chatservice2 = _interopRequireDefault(_chatservice);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChatBody = function (_Component) {
    _inherits(ChatBody, _Component);

    function ChatBody(props) {
        _classCallCheck(this, ChatBody);

        var _this = _possibleConstructorReturn(this, (ChatBody.__proto__ || Object.getPrototypeOf(ChatBody)).call(this, props));

        _this.scrollToLastMessageOfChatMessageBody = function () {
            _this.elChatMessageBody.scrollTop = _this.elChatMessageBody.scrollHeight;
            // this.elChatMessageBody.scrollIntoView({block: "end", behavior: "smooth"}) // NOT WORKING AS EXPECTED
        };

        _this.loadHistoryMessages = function () {
            _this.props.loadHistoryMessages();
        };

        _this.getNewMeeting = function () {
            var chatConfig = {
                visitor: { name: _this.props.user.name, initialMessage: "" },
                style: {
                    position: "right-bottom",
                    skinName: "blue"
                },
                container: "chat-container",
                custom_data: { "client_user_id": _this.props.user.client_user_id, "client_user_name": _this.props.user.name },
                user_type: _this.props.user_type, //User type should be client or agent
                display_mode: 'DISPLAYMODE_NORMAL',
                show_header: true, //true or false
                show_body: true, //true or false
                show_footer: true, //true or false
                user_join_leave_event: true, //true or false
                mask_user_typing_text: true, //true or false
                width: "320px",
                height: "350px",
                mask_user_events: true
            };
            _chatservice2.default.loadClientChat(chatConfig);
        };

        _this.state = {
            typingMessage: '',
            status: true
        };
        _this.loadParticipants = true;
        _this.elChatMessageBody = null;
        return _this;
    }

    _createClass(ChatBody, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.scrollToLastMessageOfChatMessageBody();
            var chatBody = _reactDom2.default.findDOMNode(this.elChatMessageBody);

            if (chatBody) {
                chatBody.addEventListener("wheel", function (e) {
                    var delta = e.wheelDelta || -e.detail;
                    if (delta > 0 && chatBody.scrollTop <= 0) {
                        e.preventDefault();
                        e.returnValue = false;
                    }
                    if (delta < 0 && chatBody.scrollTop >= chatBody.scrollHeight - chatBody.clientHeight) {
                        e.preventDefault();
                        e.returnValue = false;
                    }
                    return e.returnValue;
                });
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (!this.props.loader) {
                this.scrollToLastMessageOfChatMessageBody();
                if (this.loadParticipants) {
                    this.props.loadParticipantList();
                    this.loadParticipants = false;
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var loadMoreDisplayStyle = null;
            var body = null;
            var loadMore = null;
            var getNewMeetingButton = null;

            if (!this.props.historyMessagesUrl) {
                loadMoreDisplayStyle = 'none';
            } else {
                loadMoreDisplayStyle = 'none';
            }

            if (this.props.isMeetingEnded) {
                getNewMeetingButton = _react2.default.createElement(
                    'button',
                    { className: 'btn btn-primary',
                        style: { marginLeft: '80px' },
                        onClick: this.getNewMeeting
                    },
                    'Get New Chat'
                );
            }
            var loadMoreContainer = {
                alignItems: 'center',
                marginTop: 5,
                marginBottom: 5,
                display: loadMoreDisplayStyle,
                justifyContent: 'center'
            };

            if (this.props.nonWorkingHour) {
                body = _react2.default.createElement(
                    'div',
                    { ref: function ref(el) {
                            return _this2.elChatMessageBody = el;
                        }, className: 'panel-body msg_container_base', style: this.props.messageContainerHeight },
                    _react2.default.createElement(
                        'div',
                        { className: 'panel-body msg_container_base' },
                        _react2.default.createElement(
                            'div',
                            { className: 'non-working-hour' },
                            this.props.nonWorkingHourDisplayMessage
                        )
                    )
                );
            } else if (this.props.loader) {
                //Empty ChatBox with Loader.
                body = _react2.default.createElement(
                    'div',
                    { ref: function ref(el) {
                            return _this2.elChatMessageBody = el;
                        }, className: 'panel-body msg_container_base', style: this.props.messageContainerHeight },
                    _react2.default.createElement('div', { className: 'col-md-offset-5 col-xs-offset-5 col-md-2 col-xs-2 loader' }),
                    _react2.default.createElement('div', { className: 'col-md-offset-5 col-xs-offset-5' })
                );
            } else {
                //ChatBox with meeting and user data.
                var typingComp = null;

                if (this.props.user_typing_messages) {
                    typingComp = this.props.user_typing_messages.map(function (typingMessage) {
                        var user = _this2.props.participants.find(function (user) {
                            return user.id === typingMessage.sender_id;
                        });
                        //hack need revisit
                        if (!user) {
                            user = {
                                'name': 'user' + typingMessage.sender_id,
                                'pic': window.sfChat.baseApiUrl + '/img/guest.png',
                                'sender_id': 'unknown'
                            };
                            _this2.loadParticipants = true;
                            // this.props.loadParticipantList()
                        }

                        if (typingMessage.sender_id !== _this2.props.chatteeId) {
                            return _react2.default.createElement(_chatTyping2.default, {
                                key: typingMessage.message_id,
                                typingMessage: typingMessage,
                                user: user,
                                mask_user_typing_text: _this2.props.mask_user_typing_text,
                                setTypingMessage: _this2.props.setTypingMessage,
                                user_type: _this2.props.user_type });
                        }
                        return null;
                    });
                }

                var msgCount = 0;
                var messages = null;
                var content = null;

                messages = this.props.messages.map(function (message) {
                    var senderId = message.data.sender_id;
                    var user = _this2.props.participants.find(function (user) {
                        return user.id === senderId;
                    });
                    //hack need revisit
                    if (!user) {
                        user = {
                            'name': 'user' + senderId,
                            'pic': window.sfChat.baseApiUrl + '/img/guest.png'
                        };
                        _this2.loadParticipants = true;
                        // this.props.loadParticipantList()
                    }
                    if (message.action === "message_receive") {
                        msgCount++;
                        return _react2.default.createElement(_chatmessage2.default, {
                            key: message.message_id,
                            chatteeId: _this2.props.chatteeId,
                            senderId: senderId,
                            user: user,
                            text: message.data.message,
                            delivery_status: message.delivery_status,
                            time: message.server_timestamp,
                            user_pic: _this2.props.user_pic,
                            mask_user_typing_text: _this2.props.mask_user_typing_text });
                    } else if (message.action === Constants.CHAT_ACTION_FILE_SHARE) {
                        // File uploader
                        return _react2.default.createElement(_fileuploader2.default, {
                            key: message.message_id,
                            chatteeId: _this2.props.chatteeId,
                            senderId: senderId,
                            user: user,
                            files: message.data.files,
                            delivery_status: message.delivery_status,
                            time: message.server_timestamp });
                    } else if (!_this2.props.mask_user_events) {
                        if (message.action === Constants.CHAT_EVENT_USER_JOIN || message.action === Constants.CHAT_EVENT_USER_LEAVE) {
                            return _react2.default.createElement(_chatevent2.default, {
                                key: message.message_id,
                                message: message.data.message,
                                sender_timestamp: message.data.sender_timestamp });
                        }
                    } else if (message.action === "meeting_ended") {
                        return _react2.default.createElement(_chatevent2.default, {
                            key: message.message_id,
                            message: 'Chat closed by Agent',
                            sender_timestamp: message.data.sender_timestamp });
                    }
                    return null;
                });
                if (msgCount === 0) {
                    if (this.props.user_type !== 'agent') {
                        content = _react2.default.createElement(
                            'div',
                            { className: 'container-fluid', style: { display: 'flex' } },
                            _react2.default.createElement(
                                'div',
                                { className: 'row no-conversation' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-xs-12', style: { alignSelf: 'center' } },
                                    'How may I help you now'
                                )
                            )
                        );
                    }
                }

                loadMore = _react2.default.createElement(
                    'div',
                    { style: loadMoreContainer },
                    _react2.default.createElement(
                        'span',
                        { className: 'loadmore-wraper', onClick: this.loadHistoryMessages },
                        'Load More'
                    )
                );

                body = _react2.default.createElement(
                    'div',
                    { ref: function ref(el) {
                            return _this2.elChatMessageBody = el;
                        },
                        id: 'chat-body',
                        className: 'panel-body msg_container_base', style: this.props.messageContainerHeight },
                    content,
                    _react2.default.createElement(
                        'div',
                        { className: 'msg_container_base_pulldown', style: { maxHeight: this.props.messageContainerHeight.maxHeight } },
                        loadMore,
                        messages,
                        typingComp,
                        getNewMeetingButton
                    )
                );
            }
            return _react2.default.createElement(
                'div',
                null,
                body
            );
        }
    }]);

    return ChatBody;
}(_react.Component);

exports.default = ChatBody;


// WEBPACK FOOTER //
// ../chat/lib/components/chatbox/chatbody.js